import React from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { reduxForm, Field } from 'redux-form';
//import ReactDOM from 'react-dom';
//import { Editor, EditorState, RichUtils } from 'draft-js';
import { Grid } from './../../../themes/default';
import { Section, Content, Main, Buttons, FormContent, FormActions } from './../../../components/includes/container';
import { ToolbarPrimary } from './../../../components/includes/toolbar';
import { BreadcrumbItem } from './../../../components/includes/breadcrumb';
import { Ttolbar } from './../../../components/includes/ui/table';
import { InputTextField, SelectField, OptionField } from './../../../components/includes/ui/input';
import { Btn, RichTextMarkdown } from './../../../components/includes/ui';
//import { isEmail, isPasswordValid } from './../../../utilities/utils';
import { PageService } from './../../../services';

import VALIDATION from './../../../config/validation';
import TEMPLATES from './../../../config/templates';

const validate = values => {

  const errors = {}

  if (!values.title) {
    errors.title = VALIDATION.required;
  }else if(values.title.length > 2048){
    errors.title = 'The maximum is 2048 characters';
  }

  if (!values.description) {
    errors.surname = VALIDATION.required;
  }

  if (values.status === '-1') {
    errors.status = VALIDATION.required;
  }

  if (values.template === '-1') {
    errors.template = VALIDATION.required;
  }

  return errors

};

class PageCreate extends React.Component {

  constructor(props){
    super(props);
    this.state = {
      loading: false,
      sending: false
    };
  }

  /*
  ** @Service
  ** @Description: New
  */

  _Create = (values) => {

    /**
    * @State
    */
    this.setState({ loading: false, sending: true });

    PageService.create(values).then((response) => {

      /**
      * @Service find all by page
      */
      this.props.history.push('/pages');

      /**
      * @Dispatch for alert success message
      */
      this.props.AlertShow({ open: true, variant: 'success', message: `Exito, la página fue creada.` });

    }).catch((error) => {

      /**
      * @State
      */
      this.setState({ loading: true, sending: false });

      // @Dispatch alert error
      this.props.AlertShow({ open: true, variant: 'error', message: error.data.message });

    });

  }

  handleSubmitForm = (values) => {
    this._Create(values);
  }

  // _onBoldClick() {
  //    this.onChange(RichUtils.toggleInlineStyle(this.state.editorState, 'BOLD'));
  //  }

  render() {

    const { sending } = this.state;
    const { handleSubmit, invalid } = this.props;

    return (
      <Section>
        <ToolbarPrimary title="Páginas"/>
        <BreadcrumbItem to='/pages'>Páginas</BreadcrumbItem>
        <BreadcrumbItem to='/create'>Crear</BreadcrumbItem>
        <Content>

          <Main>

            <form noValidate autoComplete="off" onSubmit={ handleSubmit(this.handleSubmitForm) }>

              <Ttolbar title="Creación de página"/>

              <FormContent enabledActions>

                <Grid container spacing={24}>

                  <Grid item lg={6} md={6} sm={12} xs={12}>
                    <Field
                        name="title"
                        component={ InputTextField }
                        label="Título"
                        type="text"
                        required
                    />
                  </Grid>

                  <Grid item lg={3} md={3} sm={12} xs={12}>
                    <Field
                        name="status"
                        component={ SelectField }
                        label="Estado" required>
                          <OptionField key="-1" value="-1">Seleccionar...</OptionField>
                          <OptionField key="true" value="true">Activo</OptionField>
                          <OptionField key="false" value="false">Bloqueado</OptionField>
                    </Field>
                  </Grid>
                  <Grid item lg={3} md={3} sm={12} xs={12}>
                    <Field
                        name="template"
                        component={ SelectField }
                        label="Template" required>
                          <OptionField key="1" value="-1">Seleccionar...</OptionField>
                          { TEMPLATES.length > 0 && (
                            TEMPLATES.map(role => {
                              return(
                                <OptionField key={ role.key } value={ role.id }>{ role.name }</OptionField>
                              )
                            })
                          )}
                    </Field>
                  </Grid>

                  <Grid item lg={12} md={12} sm={12}>
                    <Field
                        name="description"
                        component={ RichTextMarkdown }
                        label="Descipción"
                        type="text"
                        required={true}
                    />
                  </Grid>

                </Grid>


              </FormContent>

              <FormActions>
                <Grid container>
                  <Grid item lg={6} md={6} sm={6} xs={6}>
                    <Buttons>
                      <Btn aria-label="Volver" icon="back" color="secondary" component={ NavLink } to="/pages">
                        Volver
                      </Btn>
                    </Buttons>
                  </Grid>
                  <Grid item lg={6} md={6} sm={6} xs={6}>
                    <Buttons align="right">
                      <Btn aria-label="Guardar página" icon="add" color="success" type="submit" disabled={ invalid } loading={ sending }>
                        Guardar página
                      </Btn>
                    </Buttons>
                  </Grid>
                </Grid>
              </FormActions>

            </form>

          </Main>

        </Content>
      </Section>
    )
  }
}

PageCreate = reduxForm({
  form: 'PageCreate',
  validate,
  initialValues: {
    status: '-1',
    template: '-1'
  }
})(PageCreate);

const mapStateToProps = (state) => {
  return {
    Alert: state.Alert
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    AlertShow: (data) => {
      dispatch({
        type: 'ALERT_SHOW',
        data: data
      });
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(PageCreate);
